var _rect, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.40002,
    width: 25.6003,
    height: 25.6,
    rx: 3,
    fill: "#0B66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75739 27.3792H3.91734V15.8592H7.75739V27.3792ZM17.1913 15.5517C19.751 15.5519 21.6063 17.2038 21.6063 20.7492V27.3792H17.7663V21.1967C17.7663 19.6479 17.2164 18.6368 15.8212 18.6367C15.3895 18.6399 14.9687 18.7748 14.6162 19.0242C14.2638 19.2736 13.9965 19.6256 13.85 20.0317C13.7498 20.3326 13.7069 20.65 13.7225 20.9667V27.3667H9.88242C9.88242 27.3667 9.88242 16.8987 9.88242 15.8467H13.7225V17.4717C14.0713 16.8666 14.5789 16.3675 15.19 16.0292C15.8011 15.6911 16.4933 15.5259 17.1913 15.5517ZM5.83737 10.253C6.11835 10.2211 6.40289 10.2485 6.67238 10.3342C6.94208 10.42 7.19129 10.5619 7.40239 10.7505C7.6133 10.9388 7.78178 11.1699 7.8974 11.428C8.013 11.6862 8.07361 11.9663 8.07365 12.2492C8.07365 12.5322 8.01303 12.8122 7.8974 13.0705C7.78183 13.3286 7.61329 13.5595 7.40239 13.748C7.19129 13.9365 6.94208 14.0784 6.67238 14.1642C6.40287 14.2499 6.11838 14.2785 5.83737 14.2467C5.3078 14.2467 4.79933 14.0362 4.42485 13.6617C4.05037 13.2872 3.83984 12.7788 3.83984 12.2492C3.83992 11.7199 4.05063 11.2123 4.42485 10.838C4.79933 10.4635 5.30778 10.253 5.83737 10.253Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.3197,
    cy: 7.68,
    rx: 7.6801,
    ry: 7.68,
    fill: "#0D9C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6119 4.14967C28.0393 3.72789 28.7217 3.73838 29.1362 4.17324C29.5506 4.60821 29.5403 5.30287 29.113 5.72471L23.555 11.2106C23.1369 11.6233 22.472 11.6233 22.0539 11.2106L19.5276 8.71729C19.1002 8.29546 19.09 7.60084 19.5044 7.16582C19.9188 6.73081 20.6013 6.72042 21.0287 7.14225L22.8034 8.89408L27.6119 4.14967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinConnected);
export default __webpack_public_path__ + "static/media/linkedin-connected.ba280812139422cf3113f71d70b61062.svg";
export { ForwardRef as ReactComponent };